import { COUNTRIES } from "@/lib/location-data"

const DIVISIONS: Record<string, string[]> = {
  AR: [
    "Liga Profesional (Primera División)",
    "Primera Nacional",
    "Primera B Metropolitana",
    "Primera C",
    "Primera D",
    "Federal A",
    "Torneo Regional Federal Amateur",
    "Liga femenina",
    "Futsal",
    "Inferiores / Juveniles",
  ],
  CO: [
    "Liga BetPlay (Primera A)",
    "Torneo BetPlay (Primera B)",
    "Tercera División",
    "Liga femenina",
    "Inferiores / Juveniles",
  ],
  MX: [
    "Liga MX",
    "Liga de Expansión MX",
    "Liga Premier",
    "Tercera División",
    "Liga MX Femenil",
    "Inferiores / Juveniles",
  ],
  CL: [
    "Primera División",
    "Primera B",
    "Segunda División",
    "Tercera División",
    "Inferiores / Juveniles",
  ],
  PE: [
    "Liga 1",
    "Liga 2",
    "Copa Perú",
    "Liga femenina",
    "Inferiores / Juveniles",
  ],
  EC: [
    "Liga Pro (Serie A)",
    "Serie B",
    "Segunda Categoría",
    "Inferiores / Juveniles",
  ],
  UY: [
    "Primera División",
    "Segunda División",
    "Primera Amateur",
    "Liga femenina",
    "Inferiores / Juveniles",
  ],
  PY: [
    "Primera División",
    "División Intermedia",
    "Primera B",
    "Inferiores / Juveniles",
  ],
  BO: [
    "División Profesional",
    "Liga Nacional B",
    "Copa Simón Bolívar",
    "Inferiores / Juveniles",
  ],
  VE: [
    "Liga FUTVE (Primera División)",
    "Segunda División",
    "Tercera División",
    "Inferiores / Juveniles",
  ],
  BR: [
    "Série A",
    "Série B",
    "Série C",
    "Série D",
    "Campeonato Estadual",
    "Liga feminina",
    "Inferiores / Juveniles",
  ],
  ES: [
    "LaLiga",
    "LaLiga 2",
    "Primera Federación",
    "Segunda Federación",
    "Tercera Federación",
    "Liga femenina",
    "Inferiores / Juveniles",
  ],
}

const FALLBACK_DIVISIONS = [
  "Primera División",
  "Segunda División",
  "Tercera División",
  "Liga Amateur",
  "Liga femenina",
  "Inferiores / Juveniles",
]

/**
 * Get divisions for a country by name.
 * Falls back to a generic list for countries without specific data.
 */
export function getDivisionsForCountry(countryName: string): string[] {
  const country = COUNTRIES.find((c) => c.name === countryName)
  if (!country) return FALLBACK_DIVISIONS
  return DIVISIONS[country.code] ?? FALLBACK_DIVISIONS
}
